import { Injectable } from '@angular/core';
import { App, AppLaunchUrl } from '@capacitor/app';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  addUrlOpenListener(callback: (event: any) => void) {
    App.addListener('appUrlOpen', callback);
  }

  async getLaunchUrl(): Promise<AppLaunchUrl | undefined> {
    try {
      return await App.getLaunchUrl();
    } catch (error) {
      // getLaunchUrl throws an error if no launch URL exists
      // This is expected behavior when app wasn't launched via URL
      return undefined;
    }
  }
}
